'use client';

export { Clickable } from './Clickable';
export type { ClickableT } from './Clickable';
